import React, { CSSProperties } from 'react';
import { renderIcon } from '../../utils/iconHelper';

/**
 * Props do componente Header
 */
export interface HeaderProps {
  /** Título do header */
  title?: string;
  /** Subtítulo do header */
  subtitle?: string;
  /** Ícone customizável (ReactNode, URL de imagem, SVG, emoji ou base64) */
  icon?: React.ReactNode | string;
  /** Callback para fechar o widget (mode: window) */
  onClose?: () => void;
  /** Estilos do container do header */
  containerStyle?: CSSProperties;
  /** Estilos do título */
  titleStyle?: CSSProperties;
  /** Estilos do subtítulo */
  subtitleStyle?: CSSProperties;
  /** Estilos do ícone */
  iconStyle?: CSSProperties;
}

/**
 * Componente de cabeçalho do chat com suporte a título, subtítulo e ícone
 */
export const Header: React.FC<HeaderProps> = ({
  title = 'Chat',
  subtitle,
  icon,
  onClose,
  containerStyle,
  titleStyle,
  subtitleStyle,
  iconStyle,
}) => {
  return (
    <div style={containerStyle}>
      {renderIcon(icon, iconStyle)}
      <div style={{ flex: 1 }}>
        <h2 style={titleStyle}>{title}</h2>
        {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
      </div>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            fontSize: '1.5rem',
            padding: '0.25rem 0.5rem',
            opacity: 0.8,
            transition: 'opacity 0.2s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.opacity = '1')}
          onMouseLeave={(e) => (e.currentTarget.style.opacity = '0.8')}
          aria-label="Fechar chat"
        >
          ×
        </button>
      )}
    </div>
  );
};
